
































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import InputPageWrapper from '@/views/components/input/InputPageWrapper.vue';

import { designStore } from '@/store/store';
import { UnitSystem } from '@/interfaces/units';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import { PSI_TO_MPA } from '@/lib/unitConversion/unitConversionFactors';
import { ILayerDef } from '@/modules/design/interfaces/shared';
import GenericPavementDiagram from '@/modules/design/views/components/GenericPavementDiagram.vue';
import { minValue, required } from 'vuelidate/lib/validators';
import { Route } from 'vue-router';
import { createConcreteValidations } from '@/modules/design/lib/validations/concrete';
import ValidatedInputPageWrapper from '@/views/components/input/ValidatedInputPageWrapper.vue';


@Component({
  components: {
    ValidatedInputPageWrapper,
    GenericPavementDiagram,
    PxDropdown,
    InputPageWrapper,
    PxNumberInput,
  },
  validations: {
    scenarioImperial: {
      baseModulus_psi: {
        required,
        minValue: minValue(0),
      },
      baseThickness_in: {
        required,
        minValue: minValue(0),
      },
      drainageFactor: {
        required,
        minValue: minValue(0),
      },
      slabFrictionCoefficient: {
        required,
        minValue: minValue(0),
      },
      subgradeReactionModulus_psiPerIn: {
        required,
        minValue: minValue(0),
      },
    },
  },
})
export default class NewConcreteSubstructure extends Vue {
  scenarioType = 'New Concrete';

  @Prop() readonly pxDesignId!: string;

  @Prop() readonly page!: number;

  get scenario() {
    return designStore.currentConcrete;
  }

  get scenarioImperial() {
    return designStore.currentConcreteImperial;
  }

  validations() {
    return createConcreteValidations(this.scenarioImperial);
  }

  sync() {
    designStore.setCurrentConcreteScenario(this.scenario);
  }

  save() {
    this.sync();
    designStore.saveCurrentConcreteScenario();
  }

  beforeRouteLeave(to: Route, from: Route, next:Function) {
    this.save();
    next();
  }

  get unitSystemIsImperial() {
    return this.scenario.unitSystem === UnitSystem.Imperial;
  }


  baseLayerTypes: { [index: string]: { text: string, min: number, max: number, baseModulus_psi: number, coefficient: number } } = {
    'Fine-grained soil': {
      text: 'Fine-grained soil',
      min: 0,
      max: 0,
      baseModulus_psi: 3000,
      coefficient: 1.3,
    },
    Sand: {
      text: 'Sand',
      min: 0,
      max: 0,
      baseModulus_psi: 10000,
      coefficient: 0.8,
    },
    Aggregate: {
      text: 'Aggregate',
      min: 0,
      max: 0,
      baseModulus_psi: 15000,
      coefficient: 1.4,
    },
    'Lime-stabilized clay': {
      text: 'Lime-stabilized clay',
      min: 0,
      max: 0,
      baseModulus_psi: 20000,
      coefficient: 3.0,
    },
    'Asphalt-treated gravel': {
      text: 'Asphalt-treated gravel',
      min: 0,
      max: 0,
      baseModulus_psi: 300000,
      coefficient: 5.8,
    },
    'Cement-treated gravel': {
      text: 'Cement-treated gravel',
      min: 0,
      max: 0,
      baseModulus_psi: 1000000,
      coefficient: 34,
    },
  };

  get layers(): ILayerDef[] {
    return [
      {
        name: 'Rigid (JPCP)',
        type: 'concrete',
        thickness: null,
        unit: this.lengthUnit,
      },
      {
        name: 'Base',
        type: 'base',
        thickness: this.scenarioImperial.baseThickness_in,
        unit: this.lengthUnit,
      },
      {
        name: 'Subgrade',
        type: 'subgrade',
        thickness: null,
        unit: this.lengthUnit,
      },
    ];
  }


  baseLayerTypeOptions = Object.keys(this.baseLayerTypes).map((k) => ({ value: k, text: k }));

  setBaseLayerType() {
    this.scenario.slabFrictionCoefficient = this.baseLayerTypes[this.scenario.baseLayerType || 'Fine-grained soil'].coefficient;

    if (this.scenario.unitSystem === UnitSystem.Imperial) {
      this.scenario.baseModulus_psi = this.baseLayerTypes[this.scenario.baseLayerType || 'Fine-grained soil'].baseModulus_psi;
    } else {
      this.scenario.baseModulus_mpa = this.baseLayerTypes[this.scenario.baseLayerType || 'Fine-grained soil'].baseModulus_psi * PSI_TO_MPA;
    }

    this.sync();
  }

  get pressureUnit() {
    return this.unitSystemIsImperial ? 'psi' : 'MPa';
  }

  get lengthUnit() {
    return this.unitSystemIsImperial ? 'in' : 'cm';
  }
}

